import { useTranslation } from 'react-i18next';

import { TabsContent } from '@/components/ui/tabs';
import ContextSection from '@/modules/tryIt/components/ContextSection';

interface ContextTabProps {
  hasTurnSelected: boolean;
}

export const ContextTab = ({ hasTurnSelected }: ContextTabProps) => {
  const { t } = useTranslation();

  return (
    <TabsContent value="context" className="flex-1 space-y-2 overflow-y-auto p-4">
      {hasTurnSelected ? (
        <ContextSection />
      ) : (
        <p className="text-sm text-muted-foreground">
          {t('simulations.select_turn_to_see_context')}
        </p>
      )}
    </TabsContent>
  );
};
